module.exports = __webpack_public_path__ + "static/media/avatar.09506575.jpg";